import React from 'react'
import { styled } from 'styled-components'
import Image from 'next/image'
import { usePalette } from 'color-thief-react'
import { useRouter } from 'next/router'
import { urlParser } from '@/util/imgHelpers'

export const DropCard = ({ drop, isNew }) => {
  const router = useRouter()
  const { fields, sys } = drop
  const { cover, title, issue, dropDate } = fields

  const issueCover = urlParser(cover?.fields?.file?.url)
  const dropId = sys.id
  const issueUrl = issue?.fields?.issueUrl

  const { data: palette = [] } = usePalette(cover?.fields?.file?.url, 2, 'rgbString', { crossOrigin: true })

  return (
    <Card onClick={() => router.push(`/issues/${issueUrl}/${dropId}`)} palette={palette}>
      {isNew && <NewBadge>NEW</NewBadge>}
      <ImageContainer>
        <Image 
          src={issueCover} 
          alt={title}
          layout="fill"
          objectFit="cover"
        />
        <Overlay palette={palette} />
      </ImageContainer>
      <Content>
        <Title>{title}</Title>
        <Meta>
          <ReleaseDate>{new Date(dropDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</ReleaseDate>
        </Meta>
      </Content>
    </Card>
  )
}

const Card = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  }
`

const NewBadge = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 10;
  background: #2563eb;
  color: white;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 4px;
  letter-spacing: 1px;
  text-transform: uppercase;
`

const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  overflow: hidden;
`

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 35%;
  background: linear-gradient(
    to top,
    ${props => props.palette[0] || 'rgba(0,0,0,0.8)'} 0%,
    transparent 100%
  );
  pointer-events: none;
`

const Content = styled.div`
  padding: 14px 16px 16px;
`

const Title = styled.h3`
  color: #1a1a1a;
  font-size: 1rem;
  font-family: 'Soehne-Leicht', sans-serif;
  margin: 0 0 6px 0;
  line-height: 1.3;
  font-weight: 400;
`

const Meta = styled.div`
  display: flex;
  align-items: center;
`

const ReleaseDate = styled.span`
  color: #888;
  font-size: 0.75rem;
  font-family: 'Soehne-Leicht', sans-serif;
`

